var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.programId !== 1)?_c('SkillHead'):_vm._e(),_vm._v(" "),(_vm.programId === 1)?_c('SkillTaekwondo'):(_vm.programId === 2)?_c('SkillKarate'):(_vm.programId === 12)?_c('SkillRuse'):_vm._e(),_vm._v(" "),_c('SkillCareer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0de670","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/program/components/PlayerDetail.vue
// module id = null
// module chunks = 